import { FormNameEnum } from "@shared/enum/form-name.enum";
import { IStoreSecurityState } from "./security.interface";
import { ICsrf } from "@shared/interface/security.interface";
import { getFingerPrint } from "@shared/lib/fingerprint.lib";
import { apiGetCsrf } from "@data/datasource/remote/security.api";

/**
 * Get a CSRF token according to the form name
 * @param that 
 * @param formName 
 * @returns 
 */
export async function _getCsrf(that: IStoreSecurityState, formName: FormNameEnum): Promise<ICsrf | undefined> {
  let token = that.csrfTokens?.find(c => c.formName === formName)

  if (token == null) {
    token = await apiGetCsrf({
      fingerprint: that.fingerprint,
      formName: formName
    })
      .then((response: ICsrf) => {
        if (response != null) {
          _setCsrf(that, response) 
        }
        
        return response
      })
      .catch((err: ErrorConstructor) => {
        return undefined
      });
  }

  return token
}

/**
 * Set a CSRF token according to the form name
 * @param that 
 * @param formName 
 * @returns 
 */
export function _setCsrf(that: IStoreSecurityState, token: ICsrf) {
  that.csrfTokens = that.csrfTokens?.filter(c => c.formName !== token.formName) ?? []
  that.csrfTokens?.push(token)
}

/**
 * Add a CSRF token according to the form name
 * @param that 
 * @param tokenList Array<ICsrf>
 * @returns 
 */
export function _addCsrfFromList(that: IStoreSecurityState, tokenList: Array<ICsrf>) {
  if (tokenList != null && tokenList.length > 0) {
    for(const token of tokenList) {
      if (token != null) {
        _setCsrf(that, token)
      }
    }
  }
}

/**
 * Get the current fingerprint
 * @param that 
 * @returns 
 */
export async function _getFingerprint(that: IStoreSecurityState): Promise<string> {
  if (that.fingerprint == null) {
    const f = await getFingerPrint()
    that.fingerprint = f.fingerprint
  }
  return that.fingerprint
}

/**
 * Get form names that are not in the list
 * @param that 
 * @returns 
 */
export function _getFormNameListToGet(that: IStoreSecurityState): Array<string> {
  const allFormName: Array<FormNameEnum> = FormNameEnum.toArray()
  const currentFormNameList = that.csrfTokens?.map(f => f.formName).filterNull<any>() ?? []
  const result: Array<string> = []

  allFormName.forEach(f => {
    if (!currentFormNameList.includes(f) && typeof f === 'string') {
      result.push(f)
    }
  })

  return result;
}